import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const TwitterIcon = (props: IconProps) => (
  <ChakraIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.48129 20.9751C4.93236 20.9751 2.55983 20.2279 0.562378 18.9473C0.915485 18.989 1.27479 19.0103 1.63908 19.0103C3.7537 19.0103 5.6999 18.2887 7.24462 17.0782C5.26954 17.0418 3.60266 15.7368 3.02833 13.9436C3.30387 13.9963 3.58664 14.0246 3.87747 14.0246C4.28916 14.0246 4.68789 13.9694 5.06667 13.8663C3.00178 13.4517 1.44603 11.6274 1.44603 9.44053C1.44603 9.42154 1.44603 9.40263 1.44635 9.3838C2.05496 9.72186 2.75087 9.92489 3.4908 9.94831C2.27971 9.13893 1.48281 7.7574 1.48281 6.19151C1.48281 5.36435 1.70539 4.58901 2.0939 3.92239C4.32006 6.6531 7.64585 8.45002 11.3971 8.63824C11.3202 8.3079 11.2802 7.96341 11.2802 7.60966C11.2802 5.11706 13.3011 3.09619 15.7939 3.09619C17.092 3.09619 18.2651 3.64436 19.0884 4.52158C20.1165 4.31911 21.0825 3.94347 21.9546 3.42628C21.6176 4.48021 20.9019 5.36475 19.97 5.92338C20.883 5.81426 21.7529 5.57164 22.5624 5.21266C21.9572 6.1178 21.192 6.91278 20.3102 7.54914C20.3188 7.74267 20.3232 7.93733 20.3232 8.13304C20.3232 14.0975 15.7833 20.9751 7.48129 20.9751Z"
      fill="currentColor"
    />
  </ChakraIcon>
);
